import clsx from 'clsx';
import React from 'react';

export interface NavButtonProps {
  id: string;
  name: string;
  isActive: boolean;
  onClick: (section: string) => void;
}

export const NavButton = ({ id, name, isActive, onClick }: NavButtonProps) => (
  <button
    type="button"
    onClick={() => onClick(id)}
    className={clsx(
      '-ml-[5px] border-0 border-l-[5px] border-solid border-transparent bg-transparent pl-16',
      'text-left text-button-lg font-normal text-primary-black hover:text-primary-magenta dark:hover:text-primary-pink',
      {
        'text-primary-magenta': isActive,
      }
    )}
  >
    {name}
  </button>
);
